import { useApiForm } from '../api-form'
import { urlArgs } from '../state'

export const useApiFormFileChunk = args => useApiForm(process.env.REACT_APP_API_TRANSFER, `api/v1/file-chunk-${urlArgs(args)}`)
